import CustomTable from "@/components/customTable/CustomTable";
import { Check } from "@mui/icons-material";
import {
  Box,
  Grid,
  IconButton,
  Typography,
  useMediaQuery,
} from "@mui/material";
import { useMemo, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { toast } from "react-toastify";
import {
  bookmarkDrug,
  getListOfAdvices,
  giveDrugToPatient,
  postAdvice,
  removeAdvice,
  removeDrugInBookmark,
} from "../../../../api/area";
import BookmarkIcon from "../../../../assets/SVG/bookmarkIcon";
import TrashIcon from "../../../../assets/SVG/trashIcon";
import { Loader } from "@/components/loader";

export default function TableUserDrug({
  rowData,
  notDelivered,
  areaId,
  parvandeh,
  setRowData,
  bookmark,
  moduleId,
  setDataTable,
  pageable,
  setPageable,
  totalSize,
}) {
  const [params] = useSearchParams();
  const [loading, setLoading] = useState(false);
  const [patientId] = useMemo(() => {
    return [params.get("patientId")];
  }, [params]);
  const md = useMediaQuery("(max-width:450px)");

  const colDefs = useMemo(
    () => [
      {
        headerName: "ردیف",
        valueGetter: (params) => params.node.rowIndex + 1,
        width: 100,
      },
      {
        field: "patient.name",
        headerName: "نام و نام خانوادگی",
        width: 160,
      },
      {
        headerName: "کد ملی",
        width: 130,
        cellRenderer: (x, options = {}) => {
          const isMobile = options.mobile ?? false;
          return (
            <Box
              key={`nid_${x.id}`}
              display="flex"
              alignItems="center"
              justifyContent={isMobile ? "end" : "unset"}
            >
              <Typography fontFamily="Vazirmatn" sx={{ lineHeight: "unset" }}>
                {x.data?.patient?.identifier}
              </Typography>
            </Box>
          );
        },
      },
      {
        headerName: "بیمه",
        width: 160,
        cellRenderer: (x) => {
          return (
            <Typography
              key={`insurance_${x.id}`}
              sx={{ lineHeight: "unset" }}
              fontFamily="Vazirmatn"
            >
              {x?.data?.patient?.insurance === "TAKMIL"
                ? "تکمیلی"
                : x?.data?.patient?.insurance === "MILITARY"
                  ? "نیروهای مسلح"
                  : x?.data?.patient?.insurance === "TAMIN"
                    ? "تامین اجتماعی"
                    : x?.data?.patient?.insurance === "SALAMAT"
                      ? "سلامت"
                      : "ندارد "}{" "}
            </Typography>
          );
        },
      },
      {
        headerName: "داروها",
        width: 850,
        cellRenderer: (x) => {
          return (
            <Grid
              display={"flex"}
              flexDirection={"column"}
              key={`drugs_${x.id}`}
            >
              {x.data.drugs.map((drug, index) => {
                return (
                  <Typography
                    key={`drug_${index}`}
                    fontFamily="Vazirmatn"
                    sx={{ lineHeight: "16px", fontSize: "11px" }}
                  >
                    {`دارو تجویز شده: ${drug.drugName} - بخش: ${drug.moduleName} - زمان تجویز: ${drug.createdAt} - تعداد تجویز: ${drug.suggestCount} - تعداد تحویل: ${drug.giveCount ?? 0} - زمان تحویل: ${drug.giveAt ?? ""}`}
                  </Typography>
                );
              })}
            </Grid>
          );
        },
      },
    ],
    [],
  );
  const colDefs1 = useMemo(
    () => [
      {
        headerName: "ردیف",
        valueGetter: (params) => params.node.rowIndex + 1,
        width: 100,
      },
      {
        field: "drugName",
        headerName: "نام دارو",
        width: 200,
      },
      {
        headerName: "تعداد",
        width: 80,
        cellRenderer: (x, options = {}) => {
          const isMobile = options.mobile ?? false;
          return (
            <Box
              key={`suggestCount_${x.id}`}
              display="flex"
              alignItems="center"
              justifyContent={isMobile ? "end" : "unset"}
            >
              {!bookmark ? x.data?.suggestCount : x.data?.amount}
            </Box>
          );
        },
      },
      {
        headerName: "تعداد تحویل",
        width: 120,
        editable: true,
        field: "giveCount",
        onCellClicked: (params) => {
          const isTouchDevice =
            "ontouchstart" in window || navigator.maxTouchPoints > 0;

          if (isTouchDevice) {
            params.api.startEditingCell({
              rowIndex: params.rowIndex,
              colKey: params.column.getColId(),
            });
          }
        },
        cellEditor: "agNumberCellEditor",
        onCellValueChanged: (params) => {
          setRowData((prev) =>
            prev.map((item) =>
              item.id === params.data.id
                ? { ...item, giveCount: Number(params.newValue) }
                : item,
            ),
          );
        },

        // cellRenderer: (x, options = {}) => {
        //   const isMobile = options.mobile ?? false;
        //   return (
        //     <Box
        //       key={`givenCount_${x.id}`}
        //       display="flex"
        //       alignItems="center"
        //       justifyContent={isMobile ? "end" : "end"}
        //     >
        //       <input
        //         style={{
        //           width: "50px",
        //           height: "30px",
        //           border: "none",
        //           boxShadow: "0px 1px 2px 0px #00000014",
        //           borderRadius: "9px",
        //         }}
        //         className="inputPresian"
        //         value={x.data.giveCount}
        //         onChange={(e) => x.setValue(e.target.value)}
        //       />
        //     </Box>
        //   );
        // },
      },
      {
        field: "useTimeFa",
        headerName: "زمان مصرف",
        width: 160,
      },
      {
        field: "howToUseFa",
        headerName: "طریقه مصرف",
        width: 140,
      },
      {
        field: "amountOfUseFa",
        headerName: "مقدار مصرف",
        width: 140,
      },
      {
        headerName: "عملیات",
        width: 200,
        cellRenderer: (x, options = {}) => {
          const isMobile = options.mobile ?? false;
          return (
            <Box
              key={`operation_${x.id}`}
              display="flex"
              gap="10px"
              alignItems="center"
              justifyContent={isMobile ? "end" : "unset"}
            >
              {x.data.giveAt === undefined && (
                <>
                  <Box
                    bgcolor={"#2C685C"}
                    color="white"
                    borderRadius={"9px"}
                    height="29px"
                    display="flex"
                    alignItems={"center"}
                    gap="10px"
                    p="5px"
                    sx={{ cursor: "pointer" }}
                    onClick={() => {
                      if (!bookmark) {
                        setLoading(true);
                        giveDrugToPatient(areaId, x.data?.id, {
                          amount: x.data.giveCount,
                          description: "",
                        })
                          .then(() => {
                            setRowData((prev) =>
                              prev.map((item) =>
                                item.id === x.data.id
                                  ? {
                                      ...item,
                                      giveAt: "",
                                    }
                                  : item,
                              ),
                            );
                            toast.success("تحویل داده شد");
                          })
                          .catch((y) => {
                            toast.error(y.data.msg);
                          })
                          .finally(() => setLoading(false));
                      } else {
                        //   giveDrugToPatient(areaId, x.data?.id, {
                        //     amount: Number(x.value),
                        //     description: "",
                        //   })
                        //     .then(() => {
                        //       toast.success("تحویل داده شد");
                        //     })
                        //     .catch(() => {});
                        // }
                        setLoading(true);
                        postAdvice(patientId, moduleId, x.data?.areaDrugId, {
                          amount: Number(x.value),
                          amountOfUse: x.data?.amountOfUse,
                          description: x.data?.description,
                          howToUse: x.data?.howToUse,
                          useTime: x.data?.useTime,
                        })
                          .then(() => {
                            // setDataTable([
                            //   ...dataTable,
                            //   {
                            //     amountOfUseFa: data?.amountOfUse,
                            //     drugName: areaDrugId?.value,
                            //     howToUseFa: data?.howToUse,
                            //     useTimeFa: data?.useTime,
                            //     suggestCount: Number(data?.amount),
                            //   },
                            // ]);
                            getListOfAdvices(areaId, `&patientId=${patientId}`)
                              .then((z) => setDataTable(z[0].drugs))
                              .catch(() => {});
                            toast.success("ثبت شد");
                          })
                          .catch((z) => {
                            toast.error(z?.data?.msg);
                          })
                          .finally(() => setLoading(false));
                      }
                    }}
                  >
                    <Typography color="white" fontFamily="Vazirmatn">
                      {!bookmark
                        ? md
                          ? "تحویل"
                          : "تحویل دارو"
                        : md
                          ? "افزودن"
                          : "افزودن دارو"}
                    </Typography>
                    <Check />
                  </Box>
                  <IconButton
                    onClick={() => {
                      // setDeleteModal(true);
                      // setDataRowEdit(x.data.patientInfo);
                      // console.log(x.data.id);
                      if (bookmark) {
                        removeDrugInBookmark(x.data.id)
                          .then(() => {
                            setRowData((z) => {
                              let array = [...z];
                              array = array.filter(
                                (item) => item.id !== x.data.id,
                              );
                              return array;
                            });
                          })
                          .catch(() => {});
                      } else {
                        removeAdvice(x.data.id)
                          .then(() => {
                            setRowData((z) => {
                              let array = [...z];
                              array = array.filter(
                                (item) => item.id !== x.data.id,
                              );
                              return array;
                            });
                          })
                          .catch(() => {});
                      }
                    }}
                  >
                    <TrashIcon />
                  </IconButton>
                </>
              )}
              {!bookmark && (
                <IconButton
                  onClick={() => {
                    // setDeleteModal(true);
                    // setDataRowEdit(x.data.patientInfo);
                    // console.log(x.data);
                    bookmarkDrug(x.data.drugId, {
                      howToUses: x.data.howToUse,
                      amountOfUses: x.data.amountOfUse,
                      useTimes: x.data.useTime,
                      amount: Number(x.data?.suggestCount),
                    })
                      .then(() => {
                        toast.success("منتخب شد");
                        // setRowData((z) => {
                        //   let array = [...z];
                        //   array = array.filter((item) => item.id !== x.data.id);
                        //   return array;
                        // });
                      })
                      .catch(() => {});
                  }}
                >
                  <BookmarkIcon color="#71717a" />
                </IconButton>
              )}
              {loading && <Loader />}
            </Box>
          );
        },
      },
    ],
    [],
  );

  return (
    <Grid display={"flex"} flexDirection={"column"}>
      {!parvandeh && (
        <Typography color={"var(--emr-darkblue)"} fontWeight="bold" mb={"20px"}>
          {notDelivered ? "جدول بیماران پذیرش نشده" : "جدول بیماران پذیرش شده"}
        </Typography>
      )}

      {pageable && (
        <CustomTable
          rowHeight={parvandeh ? "42px" : "80px"}
          totalElements={totalSize}
          onPageChange={(pageIndex, pageSize) => {
            setPageable({
              pageIndex: pageIndex,
              pageSize: pageSize,
            });
          }}
          pageSize={pageable.pageSize}
          currentPage={pageable.pageIndex}
          columns={parvandeh ? colDefs1 : colDefs}
          rowData={rowData}
          onCellClicked={
            !parvandeh
              ? (e) => {
                  window.open(
                    `/parvandeh?areaId=${areaId}&patientIdentifier=${e.data?.patient?.identifier}&patientIdentifierType=${e.data.patient?.identifierType}&patientId=${e.data.patient?.id}&tabName=drug`,
                    "_blank",
                  );
                }
              : undefined
          }
        />
      )}
      {!pageable && (
        <CustomTable
          needPagination={false}
          columns={parvandeh ? colDefs1 : colDefs}
          rowData={rowData}
          onCellClicked={
            !parvandeh
              ? (e) => {
                  window.open(
                    `/parvandeh?areaId=${areaId}&patientIdentifier=${e.data?.patient?.identifier}&patientIdentifierType=${e.data.patient?.identifierType}&patientId=${e.data.patient?.id}&tabName=drug`,
                    "_blank",
                  );
                }
              : undefined
          }
        />
      )}
    </Grid>
  );
}
